import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { ProjetoProduto } from '../../../models/projeto-produto.model';
import { ProjetoProdutoService } from '../../../services/projeto-produto.service';

@Component({
  selector: 'app-projeto-produto-edit',
  templateUrl: './projeto-produto-edit.component.html',
  styleUrls: ['./projeto-produto-edit.component.scss']
})
export class ProjetoProdutoEditComponent extends BaseFormComponent<ProjetoProduto> implements OnInit {

  idProjeto: number;
  actionLabel = 'Novo';
  filters: any;
  modalEtapaRef?: BsModalRef;
  proddoc: any;
  audit: AtualizacoesAudit;

  @ViewChild('modalEtapa') modalEtapa: TemplateRef<any>;

  constructor(
    private myService: ProjetoProdutoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private modalService: BsModalService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.filters = this.activatedRoute.snapshot.data['filters'];
    this.idProjeto = this.activatedRoute.snapshot.params['id'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      description: new FormControl('', Validators.required),
      unit_id: new FormControl(null),
      ds_goal: new FormControl('0,00'),
      value: new FormControl('0,00'),
      exec_duration: new FormControl(null),
      prod_template_id: new FormControl(null),
      steps: new FormArray([]),
    });

    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      if (this.entity?.steps?.length) {
        this.entity.steps.forEach(field => this.getFormArray().push(this.createFormGroup(field)));
      }

      if (!this.entity?.can_save) this.form.disable();

      this.audit = { prod_id: this.entity.id };
    }
  }

  createFormGroup(values: any = {}): FormGroup {
    return new FormGroup({
      id: new FormControl(values.id),
      name: new FormControl(values.name),
      comtemplated: new FormControl(values.comtemplated ? String(values.comtemplated) : '0'),
      prod_step_id: new FormControl(values.prod_step_id),
      prod_step_stat_id: new FormControl(values.prod_step_stat_id ?? 1),
    });
  }

  getFormArray(): FormArray {
    return this.form.get('steps') as FormArray;
  }

  addField() {
    const obj = { prod_step_id: this.proddoc?.id, name: this.proddoc?.name };

    if (!this.getFormArray().controls.some(control => control.value.prod_step_id === obj.prod_step_id)) {
      this.getFormArray().push(this.createFormGroup(obj));
    } else {
      this.msgError(`Etapa ${obj.name} já existe.`);
    }
    this.closeEtapaModal();
  }

  removeField(index: number) {
    this.getFormArray().removeAt(index);
  }

  voltar() {
    this.navigation.back(['/pre-projeto', 'projeto', this.entity?.pp_id ?? this.idProjeto, 'produtos']);
  }

  getDataCreate(): ProjetoProduto {
    const data = { ...this.form.value } as ProjetoProduto;
    if (!this.entity?.id) {
      data.pp_id = this.idProjeto;
    }
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.create(this.getDataCreate()).subscribe({
          next: (res) => {
            this.confirmation().subscribe(() => {
              this.navigation.replace(['/pre-projeto', 'projeto', 'produtos', res.id]);
            });
            this.loaded();
          },
          error: (error) => {
            this.msgError(error.error.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
      this.markControlsAsDirty();
    }
  }

  update(): void {
    if (this.form.valid && this.entity?.id) {
      this.loading();
      this.addSub(
        this.myService.update(this.getDataCreate(), this.entity.id).subscribe({
          next: () => {
            this.msgSuccess('Produto alterado com sucesso!');
            EventSharedService.get('auditRefresh').emit();
            this.loaded();
          },
          error: (error) => {
            this.msgError(error.error.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
      this.markControlsAsDirty();
    }
  }

  private markControlsAsDirty() {
    this.getFormArray().controls.forEach((form, index) => {
      Object.keys(form['controls']).forEach((key) => this.getFormArray().controls[index]['controls'][key].markAsDirty())
    })
  }

  formatarMedidaFisica(field: string, decimal = 2) {
    const value = this.maskService.formatarMedidaFisica(this.form.get(field).value, decimal);
    this.form.get(field).setValue(value);
  }

  maskNumber(event: Event, field: string) {
    const value = (event.target as HTMLInputElement).value.replace(/\D/g, '');
    this.form.get(field).setValue(value);
  }

  fieldMessageRequireds(field: string, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field: string, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  openEtapaModal() {
    this.modalEtapaRef = this.modalService.show(this.modalEtapa);
  }

  closeEtapaModal() {
    this.modalEtapaRef?.hide();
    this.proddoc = null;
  }

  changeProdTemplate() {
    this.loading();
    const id = this.form.get('prod_template_id')?.value;
    this.addSub(
      this.myService.getProdTemplate(id).subscribe({
        next: (res) => {
          this.getFormArray().clear();
          if (res?.length) {
            res.forEach(value => {
              const obj = { name: value.name, comtemplated: value.comtemplated, prod_step_id: value.id };
              this.getFormArray().push(this.createFormGroup(obj));
            });
          }
          this.loaded();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      })
    );
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: () => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.voltar();
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error.error);
      }
    });
  }
}
